import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Modal, Tooltip, Typography, CircularProgress } from '@mui/material'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Icon from '@mui/material/Icon'
import { useStyles } from '../Pathologist/inboxStyles'
import PatientCaseHistory from '../Common/PatientCaseHistoryModal'
import { ReadyForPickupColumns } from './table_def'
import { getReadyForPickupData, unassignCase } from '../../../actions'
import { RootState } from '../../../reducers'
import { UserBannerPathologist } from '../../../interfaces/user'
import { CaseStatus } from './../../../utils/displayLabels'
import TransferCaseModal from '../LabManager/TransferCaseModal'
import AssignCaseModal from '../LabManager/AssignCaseModal'
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined'
import GroupRemoveOutlinedIcon from '@mui/icons-material/GroupRemoveOutlined'
import DeleteDialog from '../../HOC/DeleteDialog'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import CustomDatagridDateRangeFilter from '../Common/CustomDatagridDateRangeFilter'
import { DataGrid, getGridStringOperators, GridFilterItem, GridFilterModel, GridFilterOperator } from '@mui/x-data-grid'
import CustomDatagridDropDownFilter from '../Common/CustomDatagridDropDownFilter'
import LaunchPremeris from '../../CaseDiagnosis/LaunchPremeris'
import {
  clearPremerisApiCache,
  clearPremerisReportApiCache,
  setCaseData,
  getTrfInfo,
  refreshCaseData,
} from '../../../actions'

interface userObj {
  id?: number
  case_id?: number
  user_id?: string
  slide_status_id?: number
}

function ReadyForPickup({ userId }) {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const readyForPickupData = useSelector((state: RootState) => state.getReadyForPickupData)
  const sentData = useSelector((state: RootState) => state.addUserDropDown)
  const [userDetails, setUserDetails] = useState<userObj>({})
  const { display_labels } = useSelector((state: RootState) => state.appConfig)
  const { role } = useSelector((state: RootState) => state.userLogin)
  const procedureData = useSelector((state: RootState) => state.getFilterProcedureCodeData)
  const refreshData = useSelector((state: RootState) => state.refreshCase)
  const [transferModalOpen, setTransferModalOpen] = useState(false)
  const [assignModalOpen, setAssignModalOpen] = useState(false)
  const [resetAssignmentOpen, setResetAssignmentOpen] = useState(false)
  const gridPageSize = 10
  const totalCount = readyForPickupData.total_count
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [pageValue, setPageValue] = useState(0)
  const [isFirstPage, setFirstPage] = useState(false)

  const [premerisOpen, setPremerisOpen] = useState(false)
  const [isReadOnlyMode, setReadOnlyMode] = useState(false)
  const { re_unassignCase_success, re_unassignCase_error } = useSelector((state: RootState) => state.unassignResponse)
  const [filterValue, setFilterValue] = useState('')
  const [filterName, setFilterName] = useState('created_datetime')
  const [sortField, setSortField] = useState('created_datetime')
  const [sortOrder, setSortOrder] = useState('asc')
  const [isFilter, setFilter] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [columnModel, setColumnModel] = useState('created_datetime')
  const [loadingStatus, setLoadingStatus] = useState(false)

  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [
      {
        id: 1,
        columnField: 'quantity',
        value: [5000, 15000],
        operatorValue: 'between',
      },
    ],
  })

  const parsedData = `${Object.values(sentData).join('')}`

  const pathologists: UserBannerPathologist[] = useSelector((state: RootState) => state.getUserListMinimalData)

  const findId = pathologists
    .filter((user: any) => {
      return user.user_name.includes(parsedData)
    })
    .map((user: any) => {
      return {
        user_id: user.user_id,
      }
    })
  let actualfindId = Object.values(findId)
    .map((user) => user.user_id)
    .toString()

  const displayReadyForPickupData = readyForPickupData?.data?.filter((val) => {
    if (parsedData.length != 0) {
      actualfindId = val.case_number
    } else {
      val.index = val.case_number
      return val
    }
  })

  const ProcedureCodeRenderer = {
    field: 'procedure_code',
    headerName: 'Case Type',
    sortable: true,
    width: 200,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    valueGetter: (params) => {
      const procedureCodeResults = procedureData.procedureCodeMap.filter((value) => {
        return value.id == params.row.procedure_code
      })
      return procedureCodeResults[0]?.display
    },
  }

  const CaseStatusRenderer = {
    field: 'workflow_stage_id',
    headerName: 'Case Status',
    sortable: true,
    width: 225,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    renderCell: (params) => {
      const caseStatus = CaseStatus(params.row.stage_id, role, display_labels)
      const statusArray = caseStatus.labelStr.split(', ')
      const style = { backgroundColor: caseStatus.labelColor }
      return (
        <>
          {statusArray.map((caseStatus) => (
            // eslint-disable-next-line react/jsx-key
            <>
              <Tooltip title={caseStatus} placement="top-start">
                <Stack direction="row" spacing={2}>
                  <Chip className={classes.chipSpacing} color="primary" style={style} label={caseStatus} />
                </Stack>
              </Tooltip>
            </>
          ))}
        </>
      )
    },
  }

  const PickupIconRender = {
    field: '',
    headerName: 'Actions',
    disableColumnMenu: true,
    width: 120,
    headerClassName: 'super-app-theme--header',
    disableClickEventBubbling: true,
    filterable: false,
    sortable: false,
    renderCell: (params) => {
      const disableTransferStages = [
        'PRIMARY_DIAGNOSIS_RESULTED_2HRWINDOW',
        'PRIMARY_DIAGNOSIS_RESULTED_RESULT_RELEASED',
        'AMEND_RESULTED_RESULT_RELEASED',
        'CORRECT_RESULTED_2HRWINDOW',
        'CORRECT_RESULTED_RESULT_RELEASED',
      ]
      const unassignTransferStages = [
        'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL',
        'PRIMARY_DIAGNOSIS_ASSIGNED_READY',
        'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS',
        'PRIMARY_DIAGNOSIS_ASSIGNED_CONSULT',
      ]
      return (
        <>
          <Tooltip title="Case History" placement="top-start">
            <Icon onClick={(event) => handleOpen(event, params.row)}>info_outlined</Icon>
          </Tooltip>
          {disableTransferStages.includes(params.row.stage_id) === false && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Transfer case" placement="top-start">
                <PeopleAltOutlinedIcon onClick={(event) => handleTransferModalOpen(event, params.row)}>
                  Transfer
                </PeopleAltOutlinedIcon>
              </Tooltip>
            </>
          )}
          {params.row.stage_id === 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL' && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Assign case" placement="top-start">
                <GroupAddOutlinedIcon onClick={(event) => handleAssignModalOpen(event, params.row)}>
                  Assign
                </GroupAddOutlinedIcon>
              </Tooltip>
            </>
          )}
          {unassignTransferStages.includes(params.row.stage_id) && (
            <>
              &nbsp;&nbsp;&nbsp;
              <Tooltip title="Unassign case" placement="top-start">
                <GroupRemoveOutlinedIcon onClick={(event) => handleResetAssignmentOpen(event, params.row)}>
                  Unassign case
                </GroupRemoveOutlinedIcon>
              </Tooltip>
            </>
          )}
        </>
      )
    },
  }

  ReadyForPickupColumns.push(ProcedureCodeRenderer)
  ReadyForPickupColumns.push(CaseStatusRenderer)
  ReadyForPickupColumns.push(PickupIconRender)

  const handleFilter = useCallback(
    (obj) => {
      setFilter(true)
      setFilterName(obj.filterField)
      setFilterValue(obj.filterValue)
      setStartDate(obj.startDate)
      setEndDate(obj.endDate)
      setSortField(obj.sortField ? obj.sortField : 'created_datetime')
    },
    [isFilter],
  )

  const quantityOnlyOperators: GridFilterOperator[] = [
    {
      label: 'Between',
      value: 'between',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }

        return null
      },
      InputComponent: CustomDatagridDateRangeFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: 'ready_for_pickup' },
    },
  ]

  const dropdownOnlyOperators: GridFilterOperator[] = [
    {
      label: 'List',
      value: 'list',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null
        }

        return null
      },
      InputComponent: CustomDatagridDropDownFilter,
      InputComponentProps: { handleFilter, sortField: sortField, caseView: 'ready_for_pickup' },
    },
  ]

  const ColumnsCustomFilters = (columnsData: any) => {
    const newReadyForPickupColumns = [...columnsData]

    if (newReadyForPickupColumns.length > 0) {
      const assignedDateIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Assigned On')
      const assignedIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Assign By')
      const caseTypeIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Case Type')
      const priorityIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Priority')
      const workflowIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Case Status')
      const statesIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Location')
      const recieveIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Receive From')
      const patientNameIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'Patient Name')
      const trfIdIndex = newReadyForPickupColumns.findIndex((col) => col.headerName === 'TRF ID')
      if (assignedDateIndex !== -1) {
        newReadyForPickupColumns[assignedDateIndex] = {
          ...newReadyForPickupColumns[assignedDateIndex],
          filterOperators: quantityOnlyOperators,
        }
      }
      if (statesIndex !== -1) {
        newReadyForPickupColumns[statesIndex] = {
          ...newReadyForPickupColumns[statesIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (assignedIndex !== -1) {
        newReadyForPickupColumns[assignedIndex] = {
          ...newReadyForPickupColumns[assignedIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (caseTypeIndex !== -1) {
        newReadyForPickupColumns[caseTypeIndex] = {
          ...newReadyForPickupColumns[caseTypeIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (priorityIndex !== -1) {
        newReadyForPickupColumns[priorityIndex] = {
          ...newReadyForPickupColumns[priorityIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (workflowIndex !== -1) {
        newReadyForPickupColumns[workflowIndex] = {
          ...newReadyForPickupColumns[workflowIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }

      if (recieveIndex !== -1) {
        newReadyForPickupColumns[recieveIndex] = {
          ...newReadyForPickupColumns[recieveIndex],
          filterOperators: dropdownOnlyOperators,
        }
      }
      if (patientNameIndex !== -1) {
        newReadyForPickupColumns[patientNameIndex] = {
          ...newReadyForPickupColumns[patientNameIndex],
          filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains'),
        }
      }
      if (trfIdIndex !== -1) {
        newReadyForPickupColumns[trfIdIndex] = {
          ...newReadyForPickupColumns[trfIdIndex],
          filterOperators: getGridStringOperators().filter((operator) => operator.value === 'startsWith'),
        }
      }
    }

    return newReadyForPickupColumns
  }

  const handleOpen = (event, rowData: any) => {
    setUserDetails(rowData)
    setOpen(true)
  }

  const handleClose = () => setOpen(false)

  const handleTransferModalOpen = (event, row: any) => {
    setUserDetails(row)
    setTransferModalOpen(true)
  }

  const handleTransferModalClose = () => setTransferModalOpen(false)

  const handleAssignModalOpen = (event, row: any) => {
    setUserDetails(row)
    setAssignModalOpen(true)
  }

  const handleAssignModalClose = () => setAssignModalOpen(false)

  const handleResetAssignmentOpen = (event, row: any) => {
    setUserDetails(row)
    setResetAssignmentOpen(true)
  }

  const handleResetAssignmentClose = () => setResetAssignmentOpen(false)

  const handlePageChange = (page, details) => {
    dispatch(
      getReadyForPickupData({
        id: `${userId}`,
        pageIndex: page + 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : columnModel,
        filterValue: filterValue,
        caseView: 'ready_for_pickup',
        startDate: startDate,
        endDate: endDate,
        sortOrder: sortOrder,
        sortField: sortField,
      }),
    )
  }

  const handleSubmit = async () => {
    await dispatch(unassignCase({ caseid: userDetails.case_id, currentid: userDetails.user_id, userid: userId }))
    setOpenSuccessSnackBar(true)
    setFirstPage(true)
    setTimeout(updateDataTable, 1500)
  }

  const updateDataTable = async () => {
    await dispatch(
      getReadyForPickupData({
        id: `${userDetails.user_id}`,
        pageIndex: 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: filterValue,
        caseView: 'ready_for_pickup',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    handleResetAssignmentClose()
  }

  const onFilterChange = async (model: GridFilterModel) => {
    setFilterName('')
    setFilterValue('')
    setStartDate('')
    setEndDate('')
    setFilterModel(model)
    if (model.items.length && model.items[0].value) {
      await onFilterApply(model)
    } else {
      await clearFilter()
      setFilter(false)
    }
  }

  const clearFilter = async () => {
    //const apiRef = useGridApiContext();
    await dispatch(
      getReadyForPickupData({
        id: `${userId}`,
        pageIndex: pageValue,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: null,
        caseView: 'ready_for_pickup',
        startDate: null,
        endDate: null,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
    //apiRef.current.hideFilterPanel()
  }
  const onFilterApply = React.useCallback(async (model: GridFilterModel) => {
    if (model.items.length) {
      if (
        (model.items[0].columnField === 'patient_first_name' || model.items[0].columnField === 'case_number') &&
        model.items[0].value &&
        model.items[0].value.length
      ) {
        const val = model.items[0].value
        setFilterValue(val)
        const name = model.items[0].columnField
        setFilterName(name)
        await dispatch(
          getReadyForPickupData({
            id: userId,
            caseView: 'ready_for_pickup',
            filterField: model.items[0].columnField,
            filterValue: val,
            startDate: null,
            endDate: null,
            sortOrder: 'asc',
            pageIndex: 0,
            pageSize: 10,
            sortField: sortField,
          }),
        )
        setFilter(true)
      }
    }
  }, [])

  const handleFilteredPageChange = async (page: any, details: any) => {
    setSortOrder(details[0].sort)
    await dispatch(
      getReadyForPickupData({
        id: `${userId}`,
        caseView: 'ready_for_pickup',
        filterField: filterName !== '' ? filterName : details[0].field,
        filterValue: filterValue,
        startDate: startDate,
        endDate: endDate,
        sortOrder: details[0].sort ? details[0].sort : 'asc',
        pageIndex: page + 1,
        pageSize: gridPageSize,
        sortField: details[0].field,
      }),
    )
  }

  const handlePremerisOpen = async (event, caseId: any, data) => {
    const filterCompletedResults = data.filter((value) => {
      return value.case_id == caseId
    })
    const patientName = `${filterCompletedResults[0].patient_last_name || ''}, ${
      filterCompletedResults[0].patient_first_name || ''
    }`
    setLoadingStatus(true)
    await handleRefreshCases(filterCompletedResults[0].case_number + '000')
    dispatch(
      setCaseData({
        pathologist: {
          first_name: filterCompletedResults[0].first_name,
          last_name: filterCompletedResults[0].last_name,
        },
        pathologistId: filterCompletedResults[0].user_id,
        caseNumber: filterCompletedResults[0].case_number,
        procedureCodeId: filterCompletedResults[0].procedure_code,
        workflowId: filterCompletedResults[0].stage_id,
        patientName: patientName,
        caseId: caseId,
        nlOrderId: filterCompletedResults[0].nl_order_id,
        userCaseWorkflowId: filterCompletedResults[0].id,
        slideStatusId: filterCompletedResults[0].slide_status_id,
        mcFlag: filterCompletedResults[0].mc_flag,
        statFlag: filterCompletedResults[0].stat_flag,
      }),
    )
    setLoadingStatus(false)
    setPremerisOpen(true)
  }

  const handleRefreshCases = async (trfBarcode) => {
    await dispatch(refreshCaseData({ trfBarcode: trfBarcode }))
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
  }

  const handlePremerisClose = async () => {
    updateTrfStartDataTable()
    await dispatch(clearPremerisApiCache())
    await dispatch(clearPremerisReportApiCache())
    setPremerisOpen(false)
  }

  const updateTrfStartDataTable = async () => {
    dispatch(
      getReadyForPickupData({
        id: `${userId}`,
        pageIndex: pageValue + 1,
        pageSize: gridPageSize,
        filterField: filterName !== '' ? filterName : 'created_datetime',
        filterValue: filterValue,
        caseView: 'ready_for_pickup',
        startDate: startDate,
        endDate: endDate,
        sortOrder: 'asc',
        sortField: sortField,
      }),
    )
  }

  return (
    <div className={classes.container}>
      <Modal
        open={refreshData && refreshData.fetchInProgress}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div>
          <CircularProgress style={{ marginLeft: '45%', marginTop: '40vh', position: 'absolute', color: '#0A688D' }} />
          <Typography
            style={{
              fontWeight: 'bolder',
              color: 'rgba(255,255,255,0.8)',
              fontSize: 'larger',
              marginLeft: '35%',
              marginTop: '47vh',
              position: 'absolute',
            }}
          >
            Refreshing the case details from LabOS...
          </Typography>
        </div>
      </Modal>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <PatientCaseHistory userDetails={userDetails} handleClose={handleClose} />
        </Box>
      </Modal>
      <TransferCaseModal
        open={transferModalOpen}
        userId={userId}
        isSearch={false}
        trfId={null}
        onClose={handleTransferModalClose}
        userDetails={userDetails}
        setFirstPage={setFirstPage}
        filterName={filterName}
        filterValue={filterValue}
        sortField={sortField}
        startDate={endDate}
        endDate={endDate}
      />
      <AssignCaseModal
        open={assignModalOpen}
        userId={userId}
        isSearch={false}
        trfId={null}
        onClose={handleAssignModalClose}
        userDetails={userDetails}
        setFirstPage={setFirstPage}
        filterName={filterName}
        filterValue={filterValue}
        sortField={sortField}
        startDate={endDate}
        endDate={endDate}
      />
      {openSuccessSnackBar && re_unassignCase_success && <SuccessSnackBar message="Successfully unassigned the case" />}
      {openSuccessSnackBar && re_unassignCase_error && <ErrorSnackBar message="Unable to unassign the case" />}
      {resetAssignmentOpen && (
        <DeleteDialog
          header="Unassign"
          open={resetAssignmentOpen}
          onClose={handleResetAssignmentClose}
          handleSubmit={handleSubmit}
        />
      )}
      <div className={classes.mt}>
        <Box
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#0d688d73',
              fontWeight: '600',
            },
            '& .MuiDataGrid-columnHeader--moving': {
              backgroundColor: 'transparent !important',
            },
            '& .MuiDataGrid-cell:hover': {
              cursor: 'pointer !important',
            },
            '& .MuiDataGrid-filterForm': { p: 2 },
          }}
        >
          {displayReadyForPickupData && (
            <DataGrid
              disableColumnSelector
              autoHeight
              pagination
              pageSize={10}
              paginationMode="server"
              rowCount={totalCount}
              page={isFirstPage ? 0 : pageValue}
              rows={displayReadyForPickupData}
              columns={ColumnsCustomFilters(ReadyForPickupColumns)}
              loading={readyForPickupData.fetchInProgress}
              onPageChange={(page, details) => {
                handlePageChange(page, details)
                setPageValue(page)
                setFirstPage(false)
              }}
              filterModel={filterModel}
              onFilterModelChange={(model) => onFilterChange(model)}
              componentsProps={{
                filterPanel: {
                  filterFormProps: {
                    // Customize inputs by passing props
                    columnInputProps: {
                      variant: 'outlined',
                      size: 'small',
                      sx: { mt: 'auto' },
                    },
                    operatorInputProps: {
                      variant: 'outlined',
                      size: 'small',
                      sx: { mt: 'auto' },
                    },
                    valueInputProps: {
                      required: true,
                    },
                  },
                  sx: {
                    // Customize inputs using css selectors
                    '& .MuiDataGrid-filterForm': { p: 2, display: 'block', width: 'fit-content' },
                    '& .MuiDataGrid-filterForm:nth-child(even)': {},
                    '& .MuiDataGrid-filterFormLinkOperatorInput': { mr: 2 },
                    '& .MuiDataGrid-filterFormColumnInput': { mr: 2, width: 150 },
                    '& .MuiDataGrid-filterFormOperatorInput': { mr: 2 },
                    '& .MuiDataGrid-filterFormValueInput': { width: 'fit-content' },
                  },
                },
                panel: {
                  sx: {
                    '& .MuiDataGrid-panelWrapper': { overflow: 'visible' },
                    '& .MuiDataGrid-panelContent': { overflow: 'visible', display: 'flex' },
                    '& .MuiFormControl-root': {
                      width: 'auto',
                      minWidth: '55px',
                      marginRight: '18px',
                      justifyContent: 'end',
                    },
                  },
                },
              }}
              onSortModelChange={(newSortModel) => {
                if (newSortModel.length) setSortField(newSortModel[0].field)
                setPageValue(0)
                handleFilteredPageChange(pageValue, newSortModel)
              }}
              onCellClick={(params, event) => {
                event.defaultMuiPrevented = true
                if (params.field === '') {
                  return
                } else {
                  setReadOnlyMode(true)
                  handlePremerisOpen(event, params.row.case_id, readyForPickupData.data)
                }
              }}
            />
          )}
        </Box>
        <Modal
          open={premerisOpen}
          onClose={handlePremerisClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <LaunchPremeris
            caseView={'ready_for_pickup'}
            urlLink={''}
            handlePremerisClose={handlePremerisClose}
            handleTRFComplete={null}
            isReadOnlyMode={isReadOnlyMode}
            isAmendFlow={false}
          />
        </Modal>
      </div>
    </div>
  )
}

export default ReadyForPickup
